import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {SelectItem} from 'primeng/api';

import {EventService} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';
import {User, UserGroup} from '../../../../core/models';
import {UserGroupService} from '../../../../core/services/user-group.service';
import {UserService} from '../../../../core/services';

@Component({
  selector: 'app-user-details-groups',
  templateUrl: './user-details-groups.component.html',
  styleUrls: ['./user-details-groups.component.scss']
})
export class UserDetailsGroupsComponent implements OnInit {
  @Input() user: User;
  userOrig: User;
  authUser: AuthUser = this.token.whoAmI();
  userGroups: SelectItem[];
  group: UserGroup;
  saving = false;
  changes = false;

  constructor(
    private router: Router,
    private token: TokenService,
    private userGroupService: UserGroupService,
    private eventService: EventService,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.userOrig = this.user;
    this.loadUserGroups();
  }


  backToList() {
    this.router.navigate(['/admin', 'user', 'list']);
  }

  loadUserGroups() {
    this.userGroupService.getAll().subscribe(
      (groups) => {
        this.userGroups = [];
        groups.forEach((group) => this.addToUserGroupList(group));
      },
    );
  }

  addToUserGroupList(group: UserGroup): void {

    if (!this.alreadyMemberOf(group)) {
      this.userGroups.push({label: group.name, value: group});
    }
  }

  alreadyMemberOf(group: UserGroup) {

    if (!this.user) {
      return false;
    }

    return this.user.userGroups.some(
      (userGroup) => {
        if (userGroup.id === group.id) {
          return true;
        }
      });
  }

  removeFromGroup(group: UserGroup) {
    const groups = this.user.userGroups;
    const index = groups.indexOf(group);
    if (index !== -1) {
      groups.splice(index, 1);
      this.changes = true;
    }
  }

  addUserToGroup(group: UserGroup) {
    if (!this.user.userGroups) {
      this.user.userGroups = [];
    }
    if (group === undefined) {
      this.eventService.warn('Please Select a group');
    }
    if (this.alreadyMemberOf(group)) {
      this.eventService.info('user is already part of this group');
    }
    if (!this.alreadyMemberOf(group)) {
      this.user.userGroups.push(group);
      this.changes = true;
    }
  }

  saveUser() {
    this.saving = true;
    this.updateUser(this.user);
  }

  updateUser(user: User) {
    this.saving = true;
    this.userService.update(user)
      .subscribe(
        (data) => {
          this.backToList();
          delete (this.changes);
          delete (this.saving);
        },
        (error) => {
          delete (this.saving);
          delete (this.changes);
        }
      );
  }
}
